import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ExternalLink, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';

const JerryFoxSection = () => {
  return (
    <section className="py-16 bg-[#FAF2E8]">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-montserrat font-bold text-[#3E2C2F] mb-4">
            Meet Jerry Fox: Brooklyn's Heroic Cat
          </h2>
          <p className="text-xl text-[#3E2C2F]/80 font-montserrat max-w-3xl mx-auto">
            Discover the incredible true story of the blind cat who saved Brooklyn Borough Hall from fire in 1904
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Column */}
          <div className="space-y-4">
            <div className="relative">
              <img
                src="/lovable-uploads/15d7c76f-2960-4c03-b123-b6dec630aaa4.png"
                alt="Jerry Fox, Brooklyn's heroic blind cat wearing spectacles"
                className="w-full h-96 object-cover rounded-lg shadow-elegant"
                loading="lazy"
              />
            </div>
            <p className="text-center text-sm text-[#3E2C2F]/70 font-montserrat italic">
              Jerry Fox, Brooklyn's heroic cat (1876–1904)
            </p>
          </div>

          {/* Content Column */}
          <div className="space-y-6">
            <div className="space-y-4 text-lg text-[#3E2C2F]/90 font-montserrat leading-relaxed">
              <p>
                For nearly 28 years, Jerry Fox was Brooklyn's most beloved civic mascot, patrolling 
                the area around Borough Hall. When he lost his sight around 1903, a local optometrist 
                provided him with custom-made spectacles—a story covered by The New York Times.
              </p>
              
              <p>
                On May 22, 1904, Jerry's urgent meows alerted officials to a fire in an unoccupied 
                courtroom at Borough Hall, saving vital municipal records and preventing potential 
                destruction of this historic landmark.
              </p>
            </div>

            <Card className="bg-white/50 border-[#C46829]/20">
              <CardContent className="pt-6">
                <h3 className="text-xl font-montserrat font-bold text-[#3E2C2F] mb-3">
                  🏛️ Help Honor Jerry's Legacy
                </h3>
                <p className="text-[#3E2C2F]/90 font-montserrat mb-4">
                  Join hundreds of supporters calling for a commemorative plaque at Brooklyn Borough Hall 
                  to honor this extraordinary cat's heroism and community spirit.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link to="/petition-jerry-fox" className="flex-1">
                    <Button 
                      className="w-full font-montserrat"
                    >
                      <ExternalLink className="mr-2 h-4 w-4" />
                      Sign the Petition
                    </Button>
                  </Link>
                  <Link to="/blog?post=jerry-fox-saves-brooklyn-borough-hall" className="flex-1">
                    <Button 
                      variant="outline" 
                      className="w-full font-montserrat"
                    >
                      <BookOpen className="mr-2 h-4 w-4" />
                      Read Full Story
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JerryFoxSection;